/**
 * Radio-group bindings (name, selected value, select handler) for filter option lists.
 * Lets RmaListFilterRadioOption read selection UI state without prop drilling.
 */
import React, { useContext } from "react";
import type { RmaListFilterOptionId } from "../rma-list-filter-radio-option";

export interface IRmaListFilterRadioGroupContext {
    name: string;
    value: RmaListFilterOptionId | null;
    onSelect: (id: RmaListFilterOptionId) => void;
}

const RmaListFilterRadioGroupContext = React.createContext<IRmaListFilterRadioGroupContext | null>(
    null,
);

interface IProviderProps extends IRmaListFilterRadioGroupContext {
    children: React.ReactNode;
}

export const RmaListFilterRadioGroupProvider: React.FC<IProviderProps> = ({
    name,
    value,
    onSelect,
    children,
}) => (
    <RmaListFilterRadioGroupContext.Provider value={{ name, value, onSelect }}>
        {children}
    </RmaListFilterRadioGroupContext.Provider>
);

export const useRmaListFilterRadioGroup = (): IRmaListFilterRadioGroupContext => {
    const context = useContext(RmaListFilterRadioGroupContext);
    if (!context) {
        throw new Error(
            "useRmaListFilterRadioGroup must be used within RmaListFilterRadioGroupProvider",
        );
    }
    return context;
};
